import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=1cf67c88&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=1cf67c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf67c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf67c88')) {
      api.createRecord('1cf67c88', component.options)
    } else {
      api.reload('1cf67c88', component.options)
    }
    module.hot.accept("./QuestionModal.vue?vue&type=template&id=1cf67c88&scoped=true&", function () {
      api.rerender('1cf67c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/QuestionModal.vue"
export default component.exports